firebird.controller('mobileHostLoginCtrl', [
    '$q',
    '$window',
    '$scope',
    '$http',
    'meetingService',
    'helperService',
    'loginAPIService',
    '$state',
    'attendeeService',
    'routerService',
    'logService',
    'growlService',
    'cookieService',
    function (
        $q,
        $window,
        $scope,
        $http,
        meetingService,
        helperService,
        loginAPIService,
        $state,
        attendeeService,
        routerService,
        logService,
        growlService,
        cookieService
    ) {
        const logger = new LogServiceWrapper(logService, 'mobileHostLoginCtrl');

        var self = this;

        self.getDefaultDomain = getDefaultDomain;
        self.selectedEnv = self.getDefaultDomain();
        self.shouldShowEnvSelection = helperService.shouldShowEnvironmentSelectionMenu;

        //General Stuff
        self.getAppLogoURL = getAppLogoURL;
        self.joinMeetingWithoutLogin = joinMeetingWithoutLogin;

        //Login Form
        self.login = login;
        self.user = {};
        self.userType = {};
        self.showEmailEntry = true;
        self.showPasswordEntry = false;

        self.userNotFound = false;
        self.isPLR = meetingService.isIntermediaPLRUser();

        self.next = next;
        self.back = back;

        self.openSignUpPage = openSignUpPage;
        self.openForgotPasswordPage = openForgotPasswordPage;
        self.shouldShowSignUpPage = shouldShowSignUpPage;

        self.clickCount = 0;
        self.click = click;

        self.digest = digest;

        self.onHandleOpenURL = onHandleOpenURL;

        $window.document.addEventListener('handleopenurl', self.onHandleOpenURL);
        $window.document.addEventListener('sticky-handleopenurl', self.onHandleOpenURL);

        $scope.$on('$destroy', function () {
            $window.document.removeEventListener('handleopenurl', self.onHandleOpenURL);
            $window.document.removeEventListener('sticky-handleopenurl', self.onHandleOpenURL);
        });

        init();

        ////////////////////////

        function click() {
            self.clickCount++;
            if (self.clickCount == 7) {
                $window.localStorage.setItem('showEnvironmentSelection', true);
                growlService.show('You are now a developer :)', 'success');
                digest();
            }
        }

        function onHandleOpenURL(e) {
            var launchUrl = e && e.detail ? e.detail : '';

            if (launchUrl) {
                if (launchUrl === 'https://www.anymeeting.com/?utm_source=mobile_sign_up') {
                    return;
                }

                var recordingId = helperService.getRecordingId(launchUrl);
                if (recordingId && recordingId !== 'unknown') {
                    $state.go('meeting-login');
                    return;
                }

                var meetingIdentifier = helperService.getMeetingIdentifier(launchUrl);
                if (meetingIdentifier !== 'unknown') {
                    $state.go('meeting-login', {});
                    return;
                }
            }
        }

        function openSignUpPage() {
            $window.open('https://www.anymeeting.com/?utm_source=mobile_sign_up', '_blank');
        }

        function openForgotPasswordPage() {
            $window.open(self.userType.passwordRecoveryUrl, '_blank');
        }

        function shouldShowSignUpPage() {
            return !meetingService.isIntermediaPLRUser();
        }

        function init() {
            logService.log('Mobile Host Login Init');
        }

        function getAppLogoURL() {
            if (meetingService.isIntermediaPLRUser()) {
                return 'img/logos/plr_logo.svg';
            } else {
                return 'img/logos/im_logo.svg';
            }
        }

        function login() {
            logService.log('Logging in user');

            var deferred = $q.defer();

            var token;
            var param = {
                email: self.user.email,
                type: self.userType.type
            };

            if (self.userType.type !== 'AnyMeeting') {
                loginAPIService
                    .getSTSToken({
                        tokenEndPoint: self.userType.tokenEndpoint,
                        Login: self.user.email,
                        Password: self.user.password
                    })
                    .then(function (msg) {
                        param.token = msg.LoginToken;
                        deferred.resolve();
                    })
                    .catch(function (e) {
                        logger.error('login', 'error getting sts token', e);
                        deferred.reject();
                    });
            } else {
                //anymeeting
                param.password = self.user.password;
                deferred.resolve();
            }

            deferred.promise
                .then(function () {
                    //Why does the aat var exist?
                    var aat = loginAPIService
                        .login(param)
                        .then(function (resp) {
                            logService.log('user successfully logged in');
                            attendeeService.setAttendeeType('host');
                            helperService.setMobileHostLoggedIn(true);
                            var expirationDate = new Date();
                            expirationDate.setMonth(expirationDate.getMonth() + 1);
                            var obj = { createdDate: new moment(), token: resp.message.token };
                            $http.defaults.headers.common.Authorization = 'Bearer ' + resp.message.token;
                            $window.localStorage.setItem('aat', JSON.stringify(obj));

                            cookieService.put('aat', resp.message.token, {
                                expires: expirationDate,
                                secure: true,
                                samesite: 'lax'
                            });
                            cookieService.put('mobile-env', helperService.getLocationHost(), {
                                expires: expirationDate,
                                secure: true,
                                samesite: 'strict'
                            });

                            routerService.setMobileHostAccountView();
                        })
                        .catch(function (e) {
                            //error
                            $scope.loginPasswordForm.password.$setValidity('required', false);
                        });
                })
                .catch(function (e) {
                    $scope.loginPasswordForm.password.$setValidity('required', false);
                });
        }

        function next() {
            if ($scope.loginEmailForm.$valid) {
                helperService.setMobileLocation(self.selectedEnv);
                loginAPIService
                    .checkUserType({ email: self.user.email })
                    .then(function (userType) {
                        self.userType = userType;
                        self.passwordResetUrl = self.user.passwordRecoveryUrl;
                        self.showEmailEntry = false;
                        self.showBackwardButton = true;
                        self.showPasswordEntry = true;
                        self.userNotFound = false;
                        self.digest();
                    })
                    .catch(function (e) {
                        self.userNotFound = true;
                    });
            }
        }

        function back() {
            $scope.loginPasswordForm.$setPristine();
            $scope.loginPasswordForm.$setUntouched();
            self.showPasswordEntry = false;
            self.showEmailEntry = true;
            self.showBackwardButton = false;
            self.digest();
        }

        function joinMeetingWithoutLogin() {
            $state.go('meeting-login');
        }

        function getDefaultDomain() {
            if (meetingService.isIntermediaPLRUser()) {
                return 'gomeet.com';
            } else {
                return 'anymeeting.com';
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
